const RoleControlled = ({ children, role, acceptedRoles }) => {
  if (acceptedRoles.indexOf(Number(role)) !== -1) {
    return children
  } else {
    return null
  }
}

export default RoleControlled



// WEBPACK FOOTER //
// ./src/components/_common/RoleControlled.js